// import { makeStyles } from '@mui/styles';
import { styled } from "@mui/material/styles"
import DatePicker from '@mui/lab/DatePicker';
import { TextField } from "@mui/material"

export const AppDatePickerStyled = styled(DatePicker)(({ theme }) => ({
  // width: "100%",
  // backgroundColor: "red"
}))
export const AppDatePickerTextStyled = styled(TextField)(({ theme }) => ({
  width: "100%",
  // backgroundColor: "red"
}))
// export const useStyles = makeStyles((theme) => ({
//   rootAppDatePicker: {
//     marginTop: 0,
//     marginBottom: 0,
//     "& .MuiOutlinedInput-root": {
//       paddingRight: 0
//     }
//   },

//   rootAppRangeDate: {
//     display: "flex",
//     "& .MuiOutlinedInput-root": {
//       paddingRight: 0
//     },
//     "& .MuiFormControl-root": {
//       margin: 0
//     }
//   },

//   rootAppRangeDate2: {
//     display: "flex",
//     alignItems: 'center',
//     "& .MuiOutlinedInput-root": {
//       paddingRight: 0
//     },
//     "& .MuiFormControl-root": {
//       margin: 0
//     },
//     "& .close-icon": {
//       marginLeft: 8,
//       cursor: 'pointer',
//     }
//   }
// }));
